import { render, staticRenderFns } from "./IcoArrowDownGrey.vue?vue&type=template&id=16b6b078"
import script from "./IcoArrowDownGrey.vue?vue&type=script&lang=js"
export * from "./IcoArrowDownGrey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports